import React from 'react'
import { MatchOverlay } from '@plvs/respawn/features/overlay/matchOverlay/MatchOverlay'

export const MatchOverlayPage: React.FC = () => {
  return <MatchOverlay />
}
